import { memo } from 'react';
import { Tab, Tabs } from '@mui/material';

interface EditTabsProps {
  currentTab: string | number;
  minWidth?: `${number}px`;
  tabs: { value: string | number; label: string }[];
  onChangeTab: (event: React.SyntheticEvent<Element, Event>, newValue: string) => void;
}

const EditTabs = ({ currentTab, minWidth, tabs, onChangeTab }: EditTabsProps) => (
  <Tabs
    allowScrollButtonsMobile
    variant="scrollable"
    scrollButtons="auto"
    value={currentTab}
    onChange={onChangeTab}
    sx={{ height: '42px', minWidth: minWidth, background: 'transparent' }}
  >
    {tabs.map((tab) => (
      <Tab
        disableRipple
        key={tab.value}
        label={tab.label}
        value={tab.value}
        sx={{
          color: tab.value === currentTab ? '#1976D2 !important' : '#00000099',
          fontFamily: 'Roboto',
          fontSize: '0.875rem',
          fontWeight: 500,
          lineHeight: '24px',
          textTransform: 'none',
          padding: '9px 16px',
          marginRight: '0px !important',
        }}
      />
    ))}
  </Tabs>
);

export const EditTabsMemo = memo(EditTabs);
